import Axios from "axios";
import { supabase } from "./supabaseClient";
import { environmentVariable } from "../auth/apiRoute";

const adminApi = Axios.create({
  baseURL: environmentVariable.apiURL,
});

adminApi.interceptors.request.use(async (config) => {
  const { data } = await supabase.auth.getSession();
  const token = data.session ? data.session.access_token : null;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default adminApi;
